import Vue from "vue";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import VueReCaptcha from "vue-recaptcha";

// Vue.use(VueReCaptcha, { siteKey: "6LfhgWYUAAAAAPUtthEcqie2LGodNjp5GJ5fsocu" });

Vue.component("vue-recaptcha", VueReCaptcha);
